/* eslint-disable no-unused-vars,class-methods-use-this */
import { PureComponent } from 'react'

/**
 * ErrorBoundary component class
 *
 * {@link https://reactjs.org/docs/error-boundaries.html}
 */
class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidMount() {
    this.state.hasError = false
    this.state.error = null
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.state.hasError = false
    this.state.error = null
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.warn(error, errorInfo)
  }

  render() {
    const { hasError, error } = this.state
    const { children, fallback } = this.props

    if (hasError) {
      if (typeof fallback === 'function') {
        return fallback(error)
      }

      if (fallback) {
        return fallback
      }

      return <h6>UI Error<p>{error.message}</p></h6>
    }

    return children
  }
}

export default ErrorBoundary
